import React, { useState, useEffect, lazy, Suspense } from "react";
import "@fontsource/poppins";
import { CookieSetting } from "cookiesetting-component";
import "./App.css";
import Loader from "./components/Loader";
import axios from "axios";
import MediaQuery from "react-responsive";
import jsonData from "./components/PostEvent/ai-branding.json"; // Import the JSON file
import { useHyperlink } from "./contexts/HyperlinkProvider.js";

const Navbar = lazy(() => import (".././src/components/PostEvent/Navbar"));
const Body = lazy(() => import(".././src/components/PostEvent/Body"));
const Footer = lazy(() => import("./components/PostEvent/CommenFooterComponent/index.js"));
const Video = lazy(() => import("./components/Video/Video.js"));
const PostEventMemories = lazy(() =>
  import("../src/components/PostEvent/PostEventMemories.js")
);
const Thankyou = lazy(() =>
  import(".././src/components/PostEvent/Thankyou.js")
);
const SubscribeForEventNotifications = lazy(() =>
  import("../src/components/PostEvent/SubscribeForEventNotifications.js")
);
const VideoHighlights = lazy(() =>
  import("../src/components/PostEvent/VideoHighlights.js")
);
const MemoriesHighlights = lazy(() =>
  import("../src/components/PostEvent/MemoriesHighlight.js")
);
const PostSocial = lazy(() =>
  import("../src/components/PostEvent/PostSocial.js")
);

const Morganintro = lazy(() =>
  import("../src/components/PostEvent/MorganIntro.js")
);
const Contact = lazy(() => import("../src/components/PostEvent/Contact.js"));
const Relieve = lazy(() =>
  import("../src/components/PostEvent/Experience/Relieve.js")
);

function App() {
  const [videoToggle, setVideoToggle] = useState(false);
  const [played, setPlayed] = useState(false);
  const [links, setLinks] = useState(null); // Set initial state as null
  const imgCDNURL = process.env.REACT_APP_POSTAMAZINGMORGAN_CDN_URL;
  const [angelAiLink, setAngelAiLink] = useState("");
  const [angelComLink, setAngelComLink] = useState("");
  const [sunwestLink, setSunWestLink] = useState("");
  const [swmcLink, setSwmcLink] = useState("");
  const [celligenceLink, setCelligenceLink] = useState("");
  const [celligenceLlcLink, setCelligenceLlcLink] = useState("");
  const [pavanLink, setPavanLink] = useState("");
  const { getHyperLink } = useHyperlink();

  useEffect(() => {
    const processContent = async () => {
      const swLink = await getHyperLink("websites", "swmc", 0);
      const swmcLink = await getHyperLink("websites", "swmc", 1);
      const aiLink = await getHyperLink("websites", "angelai", 0);
      const aiComLink = await getHyperLink("websites", "angelai", 1);
      const cellLink = await getHyperLink("websites", "celligence", 1);
      const celliLlcLink = await getHyperLink("websites", "celligence", 0);
      const pavan = await getHyperLink("profiles", "pavan", 0);
      setAngelAiLink(aiLink || "AngelAi");
      setAngelComLink(aiComLink || "AngelAi.com");
      setSunWestLink(swLink || "Sun West");
      setSwmcLink(swmcLink, "Sun West Mortgage Company, Inc.");
      setCelligenceLink(cellLink || "Celligence");
      setCelligenceLlcLink(celliLlcLink || "Celligence LLC");
      setPavanLink(pavan || "Pavan Agarwal");
    };
    processContent();
  }, [getHyperLink]);


  const handleVideo = (videoToggle) => {
    setVideoToggle(!videoToggle);
    setPlayed(true);
  };

  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const timestamp = Date.now(); // Generate a unique timestamp
        const url = `${process.env.REACT_APP_ANGELAI_JSON}?timestamp=${timestamp}`;
        const response = await axios.get(url);
        setLinks(response.data);
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);

  useEffect(() => {
    if (!links) {
      setLinks(jsonData); // Set local JSON data as fallback initially
    }
  }, []);


  return (
    <>
    <CookieSetting 
        privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
        configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
        analytics={process.env.REACT_APP_ANALYTICS_PATH}
      />
    <div className="bodyContainer">
      
      <Suspense fallback={<div />}>
        <Navbar />
      </Suspense>
      <Suspense fallback={<div />}>
        <Body handleVideo={handleVideo} videoToggle={videoToggle} links = {links} angelAiLink={angelAiLink}/>
      </Suspense>
      <Suspense fallback={<div />}>
        <Morganintro links = {links} swmcLink={swmcLink} sunwestLink={sunwestLink} angelAiLink={angelAiLink} pavanLink={pavanLink} />
      </Suspense>
      <Suspense fallback={<div />}>
        <Relieve />
      </Suspense>
      <Suspense fallback={<div />}>
        <PostEventMemories />
      </Suspense>
      <Suspense fallback={<div />}>
        <PostSocial handleVideo={handleVideo} videoToggle={videoToggle} />
      </Suspense>
      <Suspense fallback={<div />}>
        <Thankyou sunwestLink={sunwestLink}/>
      </Suspense>
      <Suspense fallback={<div />}>
        <SubscribeForEventNotifications />
      </Suspense>
      <Suspense fallback={<div />}>
        <Contact swmcLink={swmcLink} celligenceLlcLink={celligenceLlcLink}/>
      </Suspense>
      <Suspense fallback={<div />}>
        <VideoHighlights />
      </Suspense>
      <Suspense fallback={<div />}>
        <MemoriesHighlights swmcLink={swmcLink}/>
      </Suspense>
      <Suspense fallback={<div />}>
        <Footer />
      </Suspense>
      <Suspense fallback={<Loader />}>
        {played && (
          <Video handleVideo={handleVideo} videoToggle={videoToggle} />
        )}
      </Suspense>
    </div>
    </>
  );
}

export default App;
